// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ExiB","colMin":"styles_colMin__pVjlr"};